import { CommonModule } from "@angular/common";
import {
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
  ChangeDetectionStrategy,
} from "@angular/core";
import { Router } from "@angular/router";
import { BreadcrumbService, FuturesModeService } from "@services";
import { Subscription } from "rxjs";
import { SvgIconComponent } from "src/app/shared/components/social-icons/svg-icon/svg-icon.component";
import { FuturesToggleButtonComponent } from "src/app/futures/futures-toggle-button/futures-toggle-button.component";

export interface Breadcrumb {
  label: string;
  route: string;
}

@Component({
  selector: "app-breadcrumb",
  templateUrl: "./breadcrumb.component.html",
  styleUrls: ["./breadcrumb.component.scss"],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, SvgIconComponent, FuturesToggleButtonComponent],
})
export class BreadcrumbComponent implements OnInit, OnDestroy {
  public breadcrumbs: Breadcrumb[] = [];
  private _subscription: Subscription;

  constructor(
    private _breadcrumbService: BreadcrumbService,
    private _router: Router,
    private _cdr: ChangeDetectorRef,
    private _futuresModeService: FuturesModeService,
  ) {}

  public ngOnInit(): void {
    this._subscription = this._breadcrumbService.breadcrumbs$.subscribe((breadcrumbs) => {
      const isFuturesUrl = this._router.url.includes("/futures");
      const dashboardExists = breadcrumbs.some((breadcrumb) => breadcrumb.label === "Dashboard");
      const dashboardRoute: string = this._futuresModeService.isFuturesRoute()
        ? "/futures/dashboard"
        : "/dashboard";

      this.breadcrumbs =
        isFuturesUrl || dashboardExists
          ? breadcrumbs
          : [{ label: "Dashboard", route: dashboardRoute }, ...breadcrumbs];

      this._cdr.detectChanges();
    });
  }

  public ngOnDestroy(): void {
    this._subscription.unsubscribe();
  }

  public navigateToUrl(url: string): void {
    this._router.navigate([url]);
  }
}
